import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Diagnóstico en 10 minutos',
  desc: 'Descubres en qué se va tu dinero realmente.'
}, {
  num: '02',
  title: '7 días con pasos diarios',
  desc: 'Implementas el sistema de 3 sobres + reglas simples.'
}, {
  num: '03',
  title: 'Ritual quincenal de 15 min',
  desc: 'Mantienes el orden sin estrés y sin culpa.'
}];
export function HowItWorks() {
  return <section className="py-12 bg-white" data-id="element-96">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-97">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-dark text-center mb-16" data-id="element-98">
          Cómo funciona
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-99">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-brand-green/10 -z-10" data-id="element-100"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative bg-white p-6 text-center" data-id="element-101">
              <div className="w-24 h-24 bg-brand-cream rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-white shadow-lg" data-id="element-102">
                <span className="font-heading text-3xl font-bold text-brand-green" data-id="element-103">
                  {step.num}
                </span>
              </div>
              <h3 className="font-heading text-xl font-bold text-brand-dark mb-3" data-id="element-104">
                {step.title}
              </h3>
              <p className="font-sans text-brand-text/80" data-id="element-105">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}